module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74108a6e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/hospitalPage/HospitalPage.vue
// module id = 854
// module chunks = 0